import { render, staticRenderFns } from "./end-test.vue?vue&type=template&id=12056d2e&scoped=true&"
import script from "./end-test.vue?vue&type=script&lang=js&"
export * from "./end-test.vue?vue&type=script&lang=js&"
import style0 from "./end-test.vue?vue&type=style&index=0&id=12056d2e&lang=scss&scoped=true&"
import style1 from "./end-test.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12056d2e",
  null
  
)

export default component.exports